import messages from "./json/en.json";

export default {
  $vuetify: {
    dataIterator: {
      rowsPerPageText: "Items per page:",
      rowsPerPageAll: "All",
      pageText: "{0}-{1} of {2}",
      noResultsText: "No matching records found",
      nextPage: "Next page",
      prevPage: "Previous page",
    },
    dataTable: {
      rowsPerPageText: "Rows per page:",
    },
    noDataText: "No data available",
  },
  pl: {
    word: "{n} {word} | {n} {word}s",
  },
  $errors: {
    "{internal___request___error}": "Request was finished with error",
    "{ru___teacherskaya___users___validation___DenyChangeOwnRoleValidator___message}": "Changing own role is forbidden",
  },
  ...messages,
};
